//Angular Core
import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';

// Angular Modules
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

// Material Modules
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Third Party Modules
import { ToastrModule } from 'ngx-toastr';

// Services
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../services/authentication/authentication.service';

// Interfaces
import { MatIconModule } from '@angular/material/icon';
import { SuccessResponse } from '../../interfaces/Success';

@Component({
  selector: 'ForgotPassword',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ToastrModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './forgot-password-page.component.html',
  styleUrl: './forgot-password-page.component.scss',
})
export class ForgotPasswordPage {
  recoverPasswordControl!: FormControl;
  windowSize!: number;
  loading: boolean = false;

  // Dependency Injections
  private authService: AuthenticationService = inject(AuthenticationService);
  private router: Router = inject(Router);
  private toastr: ToastrService = inject(ToastrService);

  constructor() {
    this.recoverPasswordControl = new FormControl('', [
      Validators.required,
      Validators.email,
    ]);
  }

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      this.windowSize = window.innerWidth;
    }
  }

  recoverPassword(): void {
    this.loading = true
    this.authService
      .forgotPassword(this.recoverPasswordControl.value)
      .subscribe({
        next: (response: SuccessResponse) => {
          this.loading = false;

          this.toastr.success(response.message);

          this.router.navigate(['/login']);
        },
        error: (errorResponse: HttpErrorResponse) => {
          const { error } = errorResponse;

          if (error.errors) {
            let errorKeys: string[] = Object.keys(error.errors);

            errorKeys.forEach((errorKey: string) => {
              error.errors[errorKey].map((error: string) =>
                this.toastr.error(error)
              );
            });
          } else {
            this.toastr.error(errorResponse.error.error);
          }

          this.recoverPasswordControl.setErrors({ invalid: true });

          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  goBackToLoginPage(): void {
    this.router.navigate(['login']);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent): void {
    let eventTarget = event?.target as Window;
    this.windowSize = eventTarget.innerWidth;
  }
}
